
import React from 'react'
import styles from './index.module.scss'




export default class FirstBlock extends React.Component {


  render() {
    return (
      <>
        <div className={styles.secondBlock}>
          <div className={styles.main}>
            <div>
              <div className={styles.rightTools}>
                <h3>{this.props.text}</h3>
                <p>{this.props.description1}</p>
              </div>
              <div className={styles.leftTools}>
                <img src={this.props.imgAsana} width="auto" height="auto" alt='img' />
              </div>
            </div>
          </div>

          <div className={styles.back}>
            <div>
              <div className={styles.leftTools}>
                <img src={this.props.imgAsana2} width="auto" height="auto" alt='img' />
              </div>
              <div className={styles.rightTools}>
                <h3>{this.props.text2}</h3>
                <p>{this.props.description2}</p>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
